export default "__VITE_ASSET__DY24t0z6__"